import React from 'react'
import { Magazine } from '../pages/magazine/[id]'
import { MagazineBlock } from '../pages/magazine/[id]'
import { MagazineImageBlock } from '../pages/magazine/[id]'
import dayjs from 'dayjs'

interface MagazineBodyProps {
	magazine: Magazine
}

const MagazineTitle = ({ block }: { block: MagazineBlock }) => {
  if (block.title != null) {
    return ( <div className="magazine_title" dangerouslySetInnerHTML={{__html: block.title}} /> )
  } else {
    return null
  }
}

const MagazineDescription = ({ block }: { block: MagazineBlock }) => {
  if (block.description != null) {
    return ( <div className="magazine_description" dangerouslySetInnerHTML={{__html: block.description}} /> )
  } else {
    return null
  }
}

const MagazineImage = ({ block }: { block: MagazineBlock }) => {
  if (block.magazineImageBlock != null) {
    let imageBlock: MagazineImageBlock = block.magazineImageBlock
    return ( <img className="magazine_image" src={imageBlock.image.url}/> )
  } else {
    return null
  }
}

const MagazineTwoImage = ({ block }: { block: MagazineBlock }) => {
  if (block.magazineTwoImagesBlock != null && block.magazineTwoImagesBlock.length > 0) {
    return (
      <div className="magazine_two_image">
        {block.magazineTwoImagesBlock.map((imageBlock) => {
          if (imageBlock.image.url != null ) {
            return (<img className="magazine_two_image" src={imageBlock.image.url}/>)
          }
        })}
      </div>
    )
  } else {
    return null
  }
}

const MagazineThreeImage = ({ block }: { block: MagazineBlock }) => {
  if (block.magazineThirdImagesBlock != null && block.magazineThirdImagesBlock.length > 0) {
    return (
      <div className="magazine_three_image">
        {block.magazineThirdImagesBlock.map((imageBlock) => {
          if (imageBlock.image.url != null ) {
            return (<img className="magazine_three_image" src={imageBlock.image.url}/>)
          }
        })}
      </div>
    )
  } else {
    return null
  }
}

export const MagazineBody = ({magazine}: MagazineBodyProps) => {
  function handleMagazineBlock(block: MagazineBlock) {
    if (block.blockType === 'Magazines::MagazineTitleBlock' ){
      return <MagazineTitle block={block} />
    } else if (block.blockType === 'Magazines::MagazineDescBlock' ){
      return <MagazineDescription block={block} />
    } else if (block.blockType === 'Magazines::MagazineImageBlock' ){
      return <MagazineImage block={block} />
    } else if (block.blockType === 'Magazines::MagazineTwoImagesBlock' ){
      return <MagazineTwoImage block={block} />
    } else if (block.blockType === 'Magazines::MagazineImagesBlock' ){
      return <MagazineThreeImage block={block} />
    } else {
      return null
    }
  }
  return (
    <div>
      {/* order を元に昇順ソートで並び替える */}
      {/* refs https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#%E3%82%AA%E3%83%96%E3%82%B8%E3%82%A7%E3%82%AF%E3%83%88%E3%81%AE%E9%85%8D%E5%88%97%E3%81%AE%E3%82%BD%E3%83%BC%E3%83%88 */}
      {magazine.blocks.sort((a, b) => a.order - b.order).map((block, index) => (
        <div>
          {handleMagazineBlock(block)}
        </div>
      ))}
    </div>
	)

}
